import { ICommonListApiRes, ICommonQueryParams, NetworkMethodEnum } from '@/types';
import { fetcher } from '@/utils/api/dataverse/fetcher';
import { mutator } from '@/utils/api/dataverse/mutator';
import { generateQueryParamsForPagination } from '@/utils/pagination';
import { ICurrency, ICurrencyForm } from '../types';

const URL = "CurrencyApi";
const SELECT =
  "$select=dogma_name,dogma_currencysymbol,dogma_isocurrencycode,dogma_exchangerate,dogma_vatpercentage";

export const getCurrencyList = async (
  queryParams?: ICommonQueryParams
): Promise<ICommonListApiRes<ICurrency>> => {
  const query = generateQueryParamsForPagination(queryParams);
  return await fetcher(`${URL}${query}&${SELECT}`, queryParams?.pageSize);
};

export const createCurrency = async (payload: ICurrencyForm): Promise<ICurrency> => {
  return await mutator(NetworkMethodEnum.POST, URL, payload);
};

export const updateCurrency = async (data: {
  id: string;
  payload: Partial<ICurrencyForm>;
}): Promise<ICurrency> => {
  return await mutator(NetworkMethodEnum.PATCH, URL, { id: data.id, ...data.payload });
};

export const deleteCurrency = async (id: string): Promise<void> => {
  await mutator(NetworkMethodEnum.DELETE, URL, { id });
};
